import { Component, OnDestroy, inject } from '@angular/core';
import { HotToastRef } from '@ngxpert/hot-toast';

@Component({
  selector: 'support-confirm',
  host: {
    'class': 'hot-toast-message__confirm confirm'
  },
  template: `
  <div class="confirm__text" i18n="@@support.ticket.confirm_send">Подтвердите отправку</div>

  <div class="confirm__buttons">
    <button 
      type="button"
      aria-label="confirm"
      class="btn btn_green btn_icon"
      (click)="confirm()"
    >
      <i class="icon icon_check"></i>
    </button>
    <button 
      type="button" 
      class="btn btn_red btn_icon"
      aria-label="cancel"
      (click)="dismiss()"
    >
      <i class="icon icon_cross"></i>
    </button>
  </div>
  `
})
export class ConfirmComponent implements OnDestroy {
  private readonly toastRef = inject(HotToastRef, { optional: true });

  ngOnDestroy(): void {
    this.close(false);
  }

  confirm(): void {
    this.close(true);
  }

  dismiss(): void {
    this.close(false);
  }

  private close(isConfirmed: boolean): void {
    if(!this.toastRef) {
      return;
    }

    this.toastRef.data.next(isConfirmed);
    this.toastRef.close({ dismissedByAction: true });
  }
}